<div class="flex items-center justify-center min-h-screen">
  <div class="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
    <div class="text-center">
      <h2 class="text-3xl font-extrabold text-gray-900">Crear una cuenta</h2>
      <p class="mt-2 text-sm text-gray-600">Comienza tu aventura con nosotros</p>
    </div>

    <form [formGroup]="signupForm" (ngSubmit)="signupWithEmail()" class="space-y-6">
      <div class="rounded-md shadow-sm">
        <div>
          <p-inputGroup>
            <span class="inline-flex items-center px-3 text-gray-500 border border-r-0 border-gray-300 rounded-l-md sm:text-sm">
              <i class="pi pi-envelope"></i>
            </span>
            <input
              pInputText
              id="email"
              type="email"
              formControlName="email"
              placeholder="Email"
              class="relative block w-full px-3 py-2 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-none appearance-none rounded-r-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" />
          </p-inputGroup>
        </div>
        <div class="mt-4">
          <p-inputGroup>
            <span class="inline-flex items-center px-3 text-gray-500 border border-r-0 border-gray-300 rounded-l-md sm:text-sm">
              <i class="pi pi-lock"></i>
            </span>
            <input
              pInputText
              id="password"
              type="password"
              formControlName="password"
              placeholder="Password"
              class="relative block w-full px-3 py-2 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-none appearance-none rounded-r-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" />
          </p-inputGroup>
        </div>
      </div>

      <div class="flex items-start">
        <div class="flex items-center h-5">
          <p-checkbox formControlName="terms" [binary]="true" inputId="terms"></p-checkbox>
        </div>
        <div class="ml-3 text-sm">
          <label for="terms" class="font-medium text-gray-700"
            >Acepto los <a href="#" class="text-primary-600 hover:text-primary-500">terminos y condiciones</a></label
          >
        </div>
      </div>

      @if (error()) {
      <p-message severity="error" [text]="error()"></p-message>
      }

      <div>
        <p-button label="Registrarse" type="submit" styleClass="w-full" [loading]="loading()" [disabled]="signupForm.invalid"></p-button>
      </div>

      <div class="relative flex items-center justify-center">
        <div class="flex-grow border-t border-gray-200"></div>
        <span class="flex-shrink mx-4 text-xs text-gray-400 uppercase">O continua con</span>
        <div class="flex-grow border-t border-gray-200"></div>
      </div>

      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <p-button styleClass="w-full p-button-secondary" (click)="selectGoogleLogin()" [loading]="loading()">
            <i class="pi pi-google"></i>
            <span class="ml-2">Google</span>
          </p-button>
        </div>
        <div>
          <p-button styleClass="w-full p-button-secondary" (click)="selectAppleLogin()" [loading]="loading()">
            <i class="pi pi-apple"></i>
            <span class="ml-2">Apple</span>
          </p-button>
        </div>
      </div>
    </form>

    <p class="mt-6 text-sm text-center text-gray-600">
      Ya tienes una cuenta?
      <a (click)="goToLogin()" class="font-medium cursor-pointer text-primary-600 hover:text-primary-500"> Inicia sesión </a>
    </p>
  </div>
</div>
